import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Select,  Space, Spin, Switch, Table,  Tooltip,  Typography } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined, InfoOutlined,  CloudServerOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import datasourceInfoReducer from './reducer';
import { DATA_SOURCE_LIST_ERROR, DATA_SOURCE_LIST, DATA_SOURCE_LIST_SUCCESS, EDIT_DATASOURCE_CONFIG_SUCCESS, EDIT_DATASOURCE_CONFIG_ERROR, EDIT_DATASOURCE_CONFIG, DATASOURCE_CREATE, DATASOURCE_CREATE_ERROR, DATASOURCE_CREATE_SUCCESS, DATASOURCE_UPDATE_DATA, DATA_SOURCE_DELETE_SUCCESS, DATA_SOURCE_DELETE_ERROR, DATA_SOURCE_DELETE } from './constants';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function DataSource() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const initalState = {datasourceUpdateData : {}, loading: false, error: false, datasource : []};
	const [data, dispatch] = useReducer(datasourceInfoReducer, initalState);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	// const {wellalgorithmdata} = useAuth();
	useAuth();
	// const [updateId, setUpdateId]= useState();
	const [showDeleteModal, setShowDeleteModal] = useState();
	const [deleteId, setDeleteId] = useState();
	// const [overrideBtn, setOverrideBtn] = useState(false);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const [stateconfigs, setStateConfigs] = useState([{name : '', value : '' , default : '' , override : false}]);
	// const [form] = Form.useForm();	
	const navigate = useNavigate();
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const [pidsFilter, setpidsFilter] = useState();
	const { pidsData,  getPids, channelData, getChannels } = useAuth();
	const [pidsId, setPidsId] = useState(null);
	const [channelsdata, setchannels] = useState();
	const [channelId, setChannelId] = useState();
	const [existingConfig, setexistingConfigs] = useState([]);

	useEffect(() => {
		if(featuresModule.datasourceEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,412);
		loadDataSource();
		getPids(authtoken);
		if(pidsFilter!=null){
			getChannels(authtoken, pidsFilter);

		}
	}, [pidsFilter, channelsdata]);

	useEffect(()=>{
		if(pidsId != null){
			getChannels(authtoken, pidsId);

		}
	},[pidsId]);

	

	const loadDataSource = ()=>{    
		let params = '';
		if(pidsFilter){
			params += `&pidsinfoId=${pidsFilter}`;
		}

		if(channelsdata){
			params += `&channelinfoId=${channelsdata}`;
		}

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/datasource/?pipelineId=${pipelineId}&$sort[id]=-1${params}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : DATA_SOURCE_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
					dispatch({ type : DATA_SOURCE_LIST_SUCCESS, payload: response.data });
				} else {
					dispatch({ type : DATA_SOURCE_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : DATA_SOURCE_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			
		},
		{
			title: langdata && langdata.PIDS ? langdata.PIDS : 'PIDS',
			dataIndex: 'pidsinfo',
			key: 'pidsinfo',
			
		},
		{
			title: langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name',
			dataIndex: 'channelname',
			key: 'channelname',
			
		},

	];
	
	permission==='superadmin' || permission === 'admin' ? 
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {showModal(record);getChannels(authtoken,record.pidsinfoId);}} ><EditOutlined/></a>
					<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openUserModal(record);}} ><DeleteOutlined /></a>
				</Space>
			)
		}) : null;

	
	const showModal = (value) => {
		setIsEditModalOpen(true);
		dispatch({ type : DATASOURCE_UPDATE_DATA , payload : value});
		setexistingConfigs(Object.entries(value?.configs));
	};

	const handleOk = () => {
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setchannels(null);
		setChannelId(null);
		
	};
	const handleCancel = () => {
	
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setchannels(null);
		setPidsId(null);
		setChannelId(null);

	};	

	

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			channelinfoId : null,
			pidsinfoId : null
			
		},
		onSubmit: (values) => {
			if( name == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			const payload = {
				name: values.name,
				configs: {
					...buildConfigsFromState(stateconfigs),
				},
				pipelineId : parseInt(pipelineId),
				channelinfoId : values.channelinfoId,
				pidsinfoId : values.pidsinfoId

			};
			
		
			
			dispatch({ type : DATASOURCE_CREATE });
			// let data = JSON.stringify({
			// 	'name' : name,
			// 	'pipelineId':parseInt(pipelineId)
				
			// });

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/datasource`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : {
					name : payload.name,
					configs : payload.configs,
					pipelineId : payload.pipelineId,
					channelinfoId : payload.channelinfoId,
					pidsinfoId : payload.pidsinfoId
				} 
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){
						loadDataSource();		
						Modal.success({ title: langdata && langdata.DataSourcesavedsuccessfully ? langdata.DataSourcesavedsuccessfully : 'Data Source saved successfully.' });					
						dispatch({ type : DATASOURCE_CREATE_SUCCESS });

					} else {
						dispatch({ type : DATASOURCE_CREATE_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletosavedatasource ? langdata.Unabletosavedatasource : 'Unable to save data source.' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : DATASOURCE_CREATE_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavedatasource ? langdata.Unabletosavedatasource : 'Unable to save data source' });					
					}
				});
			createFormik.resetForm();
			setIsAddModalOpen(false);
			setStateConfigs([{name : '' , value : '', default : '', override : false}]);

		}
	});	
		
	const openUserModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);
	};

	const handleDelete = () => {
		dispatch({ type : DATA_SOURCE_DELETE });
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/datasource/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadDataSource();					
					Modal.success({ title: langdata && langdata.Datasourcesuccessfullydeleted ? langdata.Datasourcesuccessfullydeleted : 'Datasource successfully deleted' });					
					dispatch({ type : DATA_SOURCE_DELETE_SUCCESS });
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletedatasource ? langdata.Unabletodeletedatasource : 'Unable to delete algorithm.' });					
					dispatch ({ type : DATA_SOURCE_DELETE_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch ({ type : DATA_SOURCE_DELETE_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletedatasource ? langdata.Unabletodeletedatasource : 'Unabletodeletedatasource.' });
				}
			});
		setShowDeleteModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.DataSourceInfoContent ? langdata.DataSourceInfoContent : 'This module manages and configures data streaming and storage settings for each type of data source in the system, including data reading and handling.'} </p>
		</Card>
	);

	const buildConfigsFromValues = (values) => {
		const configsMap = {};

		Object.keys(values).forEach((k) => {
			if (k === 'name') return;

			if (k.endsWith('value')) {
				const baseKey = k.replace('value', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].value = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('default')) {
				const baseKey = k.replace('default', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].default = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('override')) {
				const baseKey = k.replace('override', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].override = values[k];
			}
			if (k.endsWith('infoContent')) {
				const baseKey = k.replace('infoContent', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].infoContent = values[k];
			}
			if (k.endsWith('sort')) {
				const baseKey = k.replace('sort', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].sort = values[k];
			}
		});

		// Return object (not array)
		return configsMap;
	};

	const buildConfigsFromState = (stateconfigs) => {
		return stateconfigs.reduce((acc, item) => {
			if (item.name && item.value !== '') {
				acc[item.name] = {
					value: !isNaN(item.value) ? parseFloat(item.value) : item.value,
					default: !isNaN(item.default) ? parseFloat(item.default) : item.default,
					override: Boolean(item.override),
					infoContent : item.infoContent,
					sort : item.sort
				};
			}
			return acc;
		}, {});
	};



	const editFilterConfig = useFormik({
		enableReinitialize: true,
		// initialValues : {
		// 	name : data.wellalgorithmUpdateData.name,
		// },
		initialValues: {
			name: data?.datasourceUpdateData?.name,
			channelinfoId : data?.datasourceUpdateData?.channelinfoId,
			pidsinfoId: data?.datasourceUpdateData?.pidsinfoId,

			...(existingConfig
				? existingConfig.reduce(
					(acc, [key, inner]) => {
						acc[`${key}value`] =inner.value;
						acc[`${key}default`] = inner.default;
						acc[`${key}override`] = inner.override;
						acc[`${key}infoContent`] = inner.infoContent;
						acc[`${key}sort`] = inner.sort;
						return acc;
					},
					{}
				)
				: {}),

		},
		onSubmit: (values) => {

			const payload = {
				name: values.name,
				pidsinfoId : values.pidsinfoId,
				channelinfoId : values.channelinfoId,	
				configs: {
					...buildConfigsFromValues(values),
					...buildConfigsFromState(stateconfigs),
				},
				
			};

			
		
			dispatch({type:EDIT_DATASOURCE_CONFIG});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/datasource/${data?.datasourceUpdateData?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data:{
					name : payload.name,
					configs : payload.configs,
					pidsinfoId : payload.pidsinfoId,
					channelinfoId : payload.channelinfoId
				}
			};
		
			axios
				.request(config)	
				.then((response) => {
							
		
					if (response.status === 200 || response.status === 201) {
		
			
						dispatch( { type: EDIT_DATASOURCE_CONFIG_SUCCESS, payload: response.data.data });
		
						Modal.success({ title: `${langdata && langdata.EditDataSourceSuccessfull ? langdata.EditDataSourceSuccessfull :'Edit Data Source Successfull'}` });
						setIsEditModalOpen(false);
						loadDataSource();
						setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
						// loadFilterConfiguration();
						// form.resetFields();
						// addModelClassification.resetForm();
						// setOpenAddDrawer(false);
		
							
					}
				})
				.catch((error) => {
					console.log(error);
							
					dispatch({ type: EDIT_DATASOURCE_CONFIG_ERROR
					});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		
		}
	});



	const handleOverride = (value, key)=>{
		editFilterConfig.setFieldValue(`${key}override`, value);
	};

	const handleFilterConfig = () => {
		// setSuppressionValues([...suppressionValues, { Start: '', End: '' }]);
		setStateConfigs([...stateconfigs, {name : '' , value : '', default : '', override : false}]);
	};

	const handleChangeConfigs = (index, key, e)=>{

		const newConfig = [...stateconfigs];
		if(key == 'override'){
			newConfig[index][key] = e;
		}else{
			newConfig[index][key] = e.target.value;
		}
		setStateConfigs(newConfig);
	};


	const handleDeleteConfig = (index) => {
		setStateConfigs(stateconfigs.filter((_, i) => i !== index));
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());
	
	let pidsfilter=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];
	let pidsModalFilter = [];
	
	pidsData && pidsData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
		pidsModalFilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	const handlepidsfilter = (value) =>{
		setpidsFilter(value);
		setchannels(null);
		
	};

	const handleSelect = (e, option)=> {
		setPidsId(e);
		if(option == 'add'){
			createFormik.setFieldValue('pidsinfoId', e);
			createFormik.setFieldValue('channelinfoId', null);
			setchannels(null);
		}
		if(option == 'edit'){
			editFilterConfig.setFieldValue('pidsinfoId', e);
			editFilterConfig.setFieldValue('channelinfoId', null);
			setchannels(null);

		}
	};
	const handleSelectChannel = (e, options)=>{
		// setchannels(e);
		setChannelId(e);
		if(options == 'add'){
			createFormik.setFieldValue('channelinfoId', e);
		}
		if(options == 'edit'){
			editFilterConfig.setFieldValue('channelinfoId', e);
		}

	};
	let channels = [];
	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});

	const handleDeleteexistingConfig = (index) => {
		setexistingConfigs(existingConfig.filter((_, i) => i !== index));
	};

	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<CloudServerOutlined  style={{fontSize:'30px'}} />
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.DataSource ? langdata.DataSource : 'Data Source'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Space>
							<Tooltip placement="bottom" title={langdata && langdata.Filterbypids ? langdata.Filterbypids :'Filter by pids'}>
																				
								<Space>
									<Select Item
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
										optionFilterProp="children"
										defaultValue={null}
										options={pidsfilter}
										onSelect={(e)=> handlepidsfilter(e)}										
									/>  
								</Space>
							</Tooltip>  
						</Space>
						<Space>
							<Tooltip placement="bottom" title={langdata && langdata.Filterbychannel ? langdata.Filterbychannel :'Filter by channel'}>
																											
								<Space>
									<Select Item
										style={{ minWidth: '200px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={
											langdata && langdata.SelectChannel
												? langdata.SelectChannel
												: 'Select Channel'
										}
										optionFilterProp="children"
										value={channelsdata}
										options={channels}
										disabled={pidsFilter==null}
										onSelect={(e) => setchannels(e)}
																									
																											
									/>  
								</Space>
							</Tooltip>  
						</Space>
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
							
							<Popover title={langdata && langdata.DataSource ? langdata.DataSource : 'Data Source'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data?.datasource && data.datasource.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data?.datasource } 
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			<Modal
				title={langdata && langdata.EditDataSource ? langdata.EditDataSource : 'Edit Data Source'}
				centered
				open={isEditModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFilterConfig.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.DataSourceName ? langdata.DataSourceName : 'Data Source Name'} rules={[{ required: false, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									onChange={editFilterConfig.handleChange} 
									disabled
									value={editFilterConfig.values.name}
								/>
							</Form.Item>
						</Col>
						
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									value={editFilterConfig.values.pidsinfoId}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'edit')}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									value={editFilterConfig.values.channelinfoId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'edit')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={12} style={{marginBottom : '15px'}}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Configuration ? langdata.Configuration:'Configuration'}</b></Typography>
						</Col>
					</Row>

					{
						existingConfig.length <= 0 ? (
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						) : null
					}

					{
						existingConfig.sort(([, a], [, b]) => a.sort - b.sort).map(([key], index) => (

							<Row gutter={24} align='middle' key={key}>
								<Col span={2} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0 ? langdata?.Sort || 'Sort' : ''}
											</Typography>
										}
									>
										<Input
											type='number'
											name={`${key}sort`}
											onChange={editFilterConfig.handleChange}
											disabled={editFilterConfig.values[`${key}override`] ? false : true}
											value={editFilterConfig.values[`${key}sort`]}
										/>
									</Form.Item>
								</Col>
								<Col span={6} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : 'none',marginTop : '10px'}}>
												{index === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>
										}
									>
										<Input
							
											disabled
											value={key}
											suffix = {
												<Popover
													title={langdata?.Info || 'Info'}
													trigger="click"
													content={
														editFilterConfig.values[`${key}override`] ? (
															<Input.TextArea
																rows={4}
																name={`${key}infoContent`}
																value={editFilterConfig.values[`${key}infoContent`] || ''}
																onChange={editFilterConfig.handleChange}
																style={{ width: 280 }}
															/>
														) : (
															<div style={{ width: 280 }}>
																{editFilterConfig.values[`${key}infoContent`] || '-'}
															</div>
														)
													}
												>
													<Avatar size={18} style={{ cursor: 'pointer' }}>
														<InfoOutlined />
													</Avatar>
												</Popover>
											}
																	
										/>
									</Form.Item>
								</Col>
								<Col span={5} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}value`}
											onChange={editFilterConfig.handleChange}
											disabled={editFilterConfig.values[`${key}override`] ? false : true}
							
											value={editFilterConfig.values[`${key}value`]}
										/>
									</Form.Item>
								</Col>
								<Col span={5} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}default`}
											disabled
											onChange={editFilterConfig.handleChange}
							
											value={editFilterConfig.values[`${key}default`]}
										/>
									</Form.Item>
								</Col>
								<Col span={4} style={{justifyContent: 'center', display : 'flex'}}  >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px', minWidth : '50px'}} >
												{index === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>
										}
									>
										<Switch
							
											size="small"
											checked={editFilterConfig.values[`${key}override`]}
											onChange={(value) => handleOverride(value, key)}
										/>
									</Form.Item>
								</Col>
								<Col span={2} style={{ marginTop : '10px' , marginLeft : '', textAlign: 'center' }}>
									<Button
										danger
										icon={<DeleteOutlined />}
										onClick={() => handleDeleteexistingConfig(index)}
										disabled={existingConfig.length === 0}
									/>
								</Col> 
							</Row>
						)
						)
					}

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>
					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<><Row gutter={24} key={stateindex}>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : 'none', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => handleChangeConfigs(stateindex, 'name', e)}
												value={item.name} 
											/>
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												value={item.value}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'} />
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value={item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'} />
										</Form.Item>
									</Col>
									<Col span={4}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Sort || 'Sort' : ''}
											</Typography>}
										>
											<Input
												type='number'
												onChange={e => handleChangeConfigs(stateindex, 'sort', e)}
												value={item.sort}
												placeholder={langdata && langdata.Sort ? langdata.Sort : 'Sort'} />
										</Form.Item>
									</Col>
									<Col span={4} style={{ justifyContent: 'center', display: 'flex' }}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px', minWidth: '50px' }}>
												{stateindex === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>}
										>
											<Switch

												size="small"
												checked={item.override}
												onChange={(e) => {
													handleChangeConfigs(stateindex, 'override', e);
												} } />
										</Form.Item>
									</Col>

									<Col span={2} style={{ marginTop: '35px', marginLeft: '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0} />
									</Col>
								</Row>
								<Row gutter={24}>
									<Col span={24}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.infoContent || 'Info Content' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'infoContent', e)}
												value={item.infoContent}
												placeholder={langdata && langdata.infoContent ? langdata.infoContent : 'Info Content'} />
										</Form.Item>	
									</Col>
								</Row></>
							);
						})
					}


					
					
					
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.AddDataSource ? langdata.AddDataSource : 'Add Data Source'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.DataSourceName ? langdata.DataSourceName : 'Data Source Name'} rules={[{ required: true, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
									onChange={createFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={12}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									defaultValue={null}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'add')}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									value={channelId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'add')}
																											
																													
								/>  
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>

					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<><Row gutter={24} key={stateindex}>
									<Col span={7}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : 'none', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => handleChangeConfigs(stateindex, 'name', e)}
												value={item.name}
											/>
											
										</Form.Item>

									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>}
										>
											<Input

												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'}
												value={item.value} />
										</Form.Item>
									</Col>
									<Col span={6}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>}
										>
											<Input

												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value={item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'} />
										</Form.Item>
									</Col>
									<Col span={3}>
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>}
										>
											<Switch

												size="small"
												checked={item.override}
												onChange={(e) => {
													handleChangeConfigs(stateindex, 'override', e);
												} } />
										</Form.Item>
									</Col>
									<Col span={2} style={{ marginTop: '35px', marginLeft: '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0} />
									</Col>
								</Row>
								<Row gutter={24} key={stateindex}>
									<Col span={12}>
									
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.infoContent || 'Info Content' : ''}
											</Typography>}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'infoContent', e)}
												value={item.infoContent}
												placeholder={langdata && langdata.infoContent ? langdata.infoContent : ''} />
										</Form.Item>		
									</Col>
									<Col span={12}>
									
										<Form.Item
											label={<Typography style={{ minHeight: stateindex == 0 ? '' : '0px', marginTop: '10px' }}>
												{stateindex === 0
													? langdata?.Sort || 'Sort' : ''}
											</Typography>}
										>
											<Input
												type='number'
												onChange={e => handleChangeConfigs(stateindex, 'sort', e)}
												value={item.sort}
												placeholder={langdata && langdata.Sort ? langdata.Sort : ''} />
										</Form.Item>		
									</Col>
									
								</Row></>	
							);
						})
					}
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethisdatasource ? langdata.Areyousureyouwanttodeletethisdatasource :'Are you sure you want to delete this data source?'}</Col>
				</Row>
			</Modal>

			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}